import { Flex, Paper, Stack } from "@mantine/core";
import React from "react";
import { withTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import Footer from "../../components/Footer";
import Headers from "../../components/Headers";

const GeneralLayout = ({ t }) => {
  return (
    <>
      <Headers />
      <Stack
        bg="rgb(248, 248, 248)"
        spacing={0}
        justify="space-between"
        style={{
          height: "100vh",
        }}
      >
        <Paper pt={"70px"} bg="rgb(248, 248, 248)">
          <Outlet />
          
        </Paper>
        <Footer />
      </Stack>
    </>
  );
};

export default withTranslation()(GeneralLayout);
